// slices/rearrange.js
import { createSlice } from "@reduxjs/toolkit";

const rearrangeSlice = createSlice({
  name: "rearrange",
  initialState: {
    answersByQuestion: {},
  },
  reducers: {
    updateRearrangeOrder: (state, action) => {
      const { questionId, newOrder } = action.payload;
      state.answersByQuestion[questionId] = newOrder;
    },
  },
});

export const { updateRearrangeOrder } = rearrangeSlice.actions;
export default rearrangeSlice.reducer;
